import { teamComparisonPitchEventsAtom, teamComparisonUnwrappedPitchEventsAtom } from '@/atoms/team/visComparison';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventMap } from '@/components/visualisations/EventMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const TeamComparisonEventMap = ({ allowInteraction, isPreview }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <EventMap
      allowInteraction={allowInteraction}
      pitchEventsAtom={teamComparisonPitchEventsAtom}
      unwrappedPitchEventsAtom={teamComparisonUnwrappedPitchEventsAtom}
      isPreview={isPreview}
    />
  </MetricKeyFallbackWrapper>
);
